"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionHeader = exports.toggleElementStyleHeight = void 0;
var classnames_1 = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var Icon_1 = require("../Icon/Icon");
var AccordionContext_1 = require("./AccordionContext");
function toggleElementStyleHeight(element, isExpand) {
    if (!(element instanceof HTMLElement)) {
        return;
    }
    var el = element;
    if (isExpand) {
        el.style.display = 'block';
        window.requestAnimationFrame(function () {
            var heightStyle = el.scrollHeight + "px";
            el.style.height = heightStyle;
            el.addEventListener('transitionend', function expandListener() {
                el.removeEventListener('transitionend', expandListener, false);
                /* istanbul ignore else */
                if (el.style.height === heightStyle) {
                    el.style.height = 'auto';
                    el.style.overflow = 'visible';
                }
            }, false);
        });
    }
    else {
        window.requestAnimationFrame(function () {
            el.style.height = el.scrollHeight + "px";
            window.requestAnimationFrame(function () {
                el.style.height = '0px';
                el.style.overflow = 'hidden';
                el.addEventListener('transitionend', function collapseListener() {
                    el.removeEventListener('transitionend', collapseListener, false);
                    /* istanbul ignore else */
                    if (el.style.height === '0px') {
                        el.removeAttribute('style');
                    }
                }, false);
            });
        });
    }
}
exports.toggleElementStyleHeight = toggleElementStyleHeight;
var AccordionHeaderWithContext = function (props) {
    var _a = props.buttonContent, buttonContent = _a === void 0 ? '' : _a, _b = props.children, children = _b === void 0 ? null : _b, className = props.className, hasPictogram = props.hasPictogram, id = props.id, onClick = props.onClick, render = props.render, shouldExpand = props.shouldExpand, targetContentId = props.targetContentId, useButton = props.useButton, useChevron = props.useChevron, context = props.context, 
    // tslint:disable-next-line: trailing-comma
    restProps = __rest(props, ["buttonContent", "children", "className", "hasPictogram", "id", "onClick", "render", "shouldExpand", "targetContentId", "useButton", "useChevron", "context"]);
    var shouldExpandProp = !!shouldExpand;
    var _c = React.useState(false), isExpanded = _c[0], setIsExpanded = _c[1];
    var _d = React.useState(null), targetContentNode = _d[0], setTargetContentNode = _d[1];
    var _e = React.useContext(AccordionContext_1.AccordionContext), collapseAll = _e.collapseAll, expandedContentId = _e.expandedContentId, isAccordion = _e.isAccordion, setExpandedContentId = _e.setExpandedContentId;
    // store target content pane Id
    React.useEffect(function () {
        setTargetContentNode(document.getElementById(targetContentId));
    }, [targetContentId]);
    // set 'isExpanded' state
    // in accordion mode - check if expandedContentId match taget content pane id
    // otherwise use 'shouldExpand' prop value (not accordion mode)
    React.useEffect(function () {
        var expandState = isAccordion
            ? expandedContentId === targetContentId
            : shouldExpandProp;
        setIsExpanded(expandState);
    }, [expandedContentId, isAccordion, shouldExpandProp, targetContentId]);
    // toggle targetContentNode expand
    React.useEffect(function () {
        if (targetContentNode) {
            toggleElementStyleHeight(targetContentNode, isExpanded);
            targetContentNode.setAttribute('aria-hidden', "" + !isExpanded);
        }
    }, [targetContentNode, isExpanded]);
    // click handler wrapper
    var handlerClick = function (e) {
        if (!targetContentNode) {
            return;
        }
        var newExpandedState = !isExpanded;
        var updateAccordionState = function () {
            if (collapseAll) {
                return setIsExpanded(newExpandedState);
            }
            /* istanbul ignore else */
            if (expandedContentId !== targetContentId && setExpandedContentId) {
                setExpandedContentId(targetContentId);
                setIsExpanded(newExpandedState);
            }
        };
        var updateCollapsibleState = function () {
            setIsExpanded(newExpandedState);
        };
        if (isAccordion) {
            updateAccordionState();
        }
        else {
            updateCollapsibleState();
        }
        // trigger may be provided onClick
        /* istanbul ignore else */
        if (typeof onClick === 'function') {
            onClick(e, {
                isExpanded: newExpandedState,
            });
        }
    };
    var classnames = (0, classnames_1.default)('accordion-header', {
        'accordion-header--clickable': useButton,
    }, {
        'accordion-header--open': isExpanded,
    }, "" + className);
    var btnClassName = (0, classnames_1.default)('accordion-header__btn', 'hc-icon', { 'withpictogram': hasPictogram }, { 'hc-icon--control-accordion-close': isExpanded }, { 'hc-icon--control-accordion-open': !isExpanded });
    var buttonAttributes = {
        'aria-controls': targetContentId,
        'aria-expanded': isExpanded,
        'aria-labelledby': id,
        onClick: handlerClick,
    };
    var buttonBlock = (React.createElement("button", __assign({ type: "button", className: btnClassName }, buttonAttributes), buttonContent));
    // for 'render prop' pattern usage
    if (typeof render === 'function') {
        return (React.createElement("div", { className: classnames, id: id },
            render({
                handleChange: handlerClick,
                isExpanded: isExpanded,
            }),
            useChevron && buttonBlock));
    }
    return useButton ? (React.createElement("button", __assign({ className: classnames, id: id, type: "button" }, buttonAttributes, restProps),
        children,
        useChevron && (React.createElement(Icon_1.Icon, { className: (0, classnames_1.default)('chevron', { 'withpictogram': hasPictogram }), symbol: isExpanded ? 'controlAccordionClose24' : 'controlAccordionOpen24' })))) : (React.createElement("div", __assign({ className: classnames, id: id }, restProps),
        children,
        buttonBlock));
};
var AccordionHeader = function (props) { return (React.createElement(AccordionContext_1.AccordionContext.Consumer, null, function (context) { return (React.createElement(AccordionHeaderWithContext, __assign({ context: context }, props))); })); };
exports.AccordionHeader = AccordionHeader;
/* tslint:disable:no-string-literal */
exports.AccordionHeader['propTypes'] = {
    className: PropTypes.string,
    hasPictogram: PropTypes.bool,
    id: PropTypes.string.isRequired,
    render: PropTypes.func,
    shouldExpand: PropTypes.bool,
    targetContentId: PropTypes.string.isRequired,
    useButton: PropTypes.bool,
    useChevron: PropTypes.bool,
};
exports.AccordionHeader['defaultProps'] = {
    className: '',
    shouldExpand: false,
    useButton: true,
    useChevron: true,
};
/* tslint:enable:no-string-literal */
